var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3496_5319)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#E6E7EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 8.02875,
    width: 17,
    height: 7.9425,
    rx: 3.5,
    fill: "#E6E7EB",
    stroke: "#F8009E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.352 14H7.194V10.664H6.15V9.716H9.396V10.664H8.352V14ZM12.213 14L12.003 13.196H10.611L10.395 14H9.12305L10.521 9.698H12.063L13.479 14H12.213ZM11.577 11.546C11.557 11.47 11.529 11.362 11.493 11.222C11.457 11.078 11.421 10.93 11.385 10.778C11.349 10.626 11.321 10.502 11.301 10.406C11.285 10.502 11.259 10.622 11.223 10.766C11.191 10.91 11.157 11.052 11.121 11.192C11.089 11.332 11.061 11.45 11.037 11.546L10.851 12.248H11.763L11.577 11.546ZM17.7966 14H16.4586L15.6246 12.662L14.7966 14H13.4886L14.9106 11.81L13.5726 9.716H14.8566L15.6306 11.042L16.3746 9.716H17.6946L16.3386 11.9L17.7966 14Z",
    fill: "#F8009E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3496_5319"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTax);
export default __webpack_public_path__ + "static/media/icon-tax.e4b6abbe412fc4d68ec7b1217e05660f.svg";
export { ForwardRef as ReactComponent };